module.exports = __webpack_public_path__ + "static/media/ROlogo.170e99ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ROlogo.png
// module id = 125
// module chunks = 0